import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import "./i18n";

// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context";
import { PermissionsProvider } from "context/PermissionsContext";
import AuthMiddleware from "middlewares/AuthMiddleware";

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <AuthMiddleware>
        <PermissionsProvider>
          <App />
        </PermissionsProvider>
      </AuthMiddleware>
    </MaterialUIControllerProvider>
  </BrowserRouter>
);
